// en_pms_reports.ts
// Translations for PMS.Reports – Live operational reporting snapshot

export const enPmsReports = {

  title: "Reports",
  subtitle: "Live operational reporting snapshot from the Ops PMS backend.",

  // ── Metrics ──────────────────────────────────────────────────────────────
  metrics: {
    occupancy:        "Occupancy",
    reservations:     "Reservations",
    checkedIn:        "Checked In",
    checkedOut:       "Checked Out",
    currentProperty:  "Current property",
    liveStatus:       "Live status",
  },

  // ── Primary table ─────────────────────────────────────────────────────────
  primary: {
    title:              "Operational Performance",
    subtitle:           "Current hotel activity from the Ops PMS reporting snapshot.",
    arrivalsToday:      "Arrivals today",
    departuresToday:    "Departures today",
    totalCharges:       "Total charges",
    totalPayments:      "Total payments",
    outstandingBalance: "Outstanding balance",
  },

  // ── Market segment table ──────────────────────────────────────────────────
  marketSegment: {
    title:            "Market Segment Mix",
    subtitle:         "Live reservation mix by market segment from the Ops PMS backend.",
    emptyLabel:       "Market segments",
    emptyValue:       "0 live market-segment records",
    reservationCount: "{{count}} reservation(s)",
  },

  // ── Source & Pickup table ─────────────────────────────────────────────────
  sourcePickup: {
    title:              "Source Production",
    subtitle:           "Live reservation production by source/channel from the Ops PMS backend.",
    emptySourceLabel:   "Source production",
    emptySourceValue:   "0 live source/channel records",
    reservationCount:   "{{count}} reservation(s)",
  },

  pickup: {
    title:      "Pickup (7d)",
    subtitle:   "Bookings created per day over the latest 7 days.",
    emptyValue: "0 live pickup rows",
  },

  meta: {
    generatedAt: "Snapshot generated",
  },

} as const;

export default enPmsReports;
